module.exports = __webpack_public_path__ + "img/asus-ux433.32cb46f8.jpg";